import { RefObject, useCallback, useEffect } from "react";

interface IUseClickOutsideArgs {
  elementRef: RefObject<HTMLElement> | RefObject<HTMLElement>[];
  onClickOutside(): void;
}

export const useClickOutside = ({ elementRef, onClickOutside }: IUseClickOutsideArgs): void => {
  const handler = useCallback(
    (event: MouseEvent) => {
      const clickedInside = Array.isArray(elementRef)
        ? elementRef.some(ref => ref.current?.contains(event.target as Node))
        : elementRef.current?.contains(event.target as Node);
      if (!clickedInside) {
        onClickOutside();
      }
    },
    [onClickOutside, elementRef]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handler);
    return (): void => document.removeEventListener("mousedown", handler);
  }, [handler]);
};
